// When running locally, route auth0 calls through localhost:3000 (proxied by Next.js)
// to avoid CORS — auth0-js treats any domain starting with "http" as a full URL.
const isLocal = process.env.NEXT_PUBLIC_APP_ENV === "local";

export default {
  domain: isLocal
    ? "http://localhost:3000"
    : (process.env.NEXT_PUBLIC_AUTH0_DOMAIN as string),
  client_id: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID as string,
  audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE as string,
  realm: "Username-Password-Authentication",
  scope:
    "openid profile email read:current_user update:current_user_metadata offline_access",
  response_type: "token id_token",
};
